/* eslint-disable import/no-unresolved */
import KeenSlider from 'https://cdn.skypack.dev/keen-slider@6.8.6'
/* eslint-enable import/no-unresolved */

class NavigationPromos extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['slides', 'slide']
  }

  connectedCallback () {
    super.connectedCallback()

    this.perViewValue = this.els?.slide?.elements?.length < 3 ? this.els?.slide?.elements?.length : 2.2

    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        loop: false,
        mode: 'free-snap',
        rubberband: false,
        slides: {
          perView: this.perViewValue,
          spacing: 10,
        },
      },
    )
  }
}

if (!customElements.get('navigation-promos')) {
  customElements.define('navigation-promos', NavigationPromos)
}
